import type {OmitStrict} from 'type-zoo'
import type {
  TMinorActionDataPayRent,
  TPortfolioNeighborhoodId,
} from '@kapitalist/contract/types'
import MinorActionPaySomething from '~/models/game/MinorActions/MinorActionPaySomething'

type PublicMembersFromApi = OmitStrict<TMinorActionDataPayRent, 'type' | 'paidWith'>

export default class MinorActionPayRent
  extends MinorActionPaySomething<TMinorActionDataPayRent>
  implements PublicMembersFromApi
{
  portfolioNeighborhoodId: TPortfolioNeighborhoodId // what neighborhood the rent we're paying was charged for

  constructor(data: TMinorActionDataPayRent) {
    super(data)
    this.portfolioNeighborhoodId = data.portfolioNeighborhoodId
  }
}
